import { render, staticRenderFns } from "./nieuw.vue?vue&type=template&id=7d173238&"
import script from "./nieuw.vue?vue&type=script&lang=js&"
export * from "./nieuw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports